import React, { useContext, useEffect, useState } from "react";
import provinceApi from "../../../api/provinceApi";
import RtlProvider from "../../../Components/RtlProvider";
import { ContextNotification, severitys } from "../../../App";
import { Paper, Typography } from "@mui/material";

import { ContextUserInfo } from "../MainPanel";
import AccessControl from "../../../Components/AccessControl";

const ProvincePanel = () => {
  const { userInfo, userPermissions, userRoles } = useContext(ContextUserInfo);
  const { open, setOpen } = useContext(ContextNotification);
  const [rows, setRows] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [loadingRows, setLoadingRows] = useState(false);
  const columns = [
    { field: "name", headerName: "نام", width: 150 }
  ];
  useEffect(() => {
    GetData();
  }, [refresh]);
  const RefreshGrid = (result) => {
    if (result)
      setRefresh(old => !old);
  }

  const GetData = () => {
    provinceApi.GetAll()
      .then((data) => {
        setRows(data.data.data)
      })
      .catch((error) => console.log(error));
  };

  return (
    <RtlProvider>
      <Typography component="h1" variant="h5" mb={2}>
        لیست استان
      </Typography>
      <Paper sx={{ width: "100%", height: "600px" }}>
        {/* <CustomDataGrid
            rows={rows}
            columns={columns}
            loading={loadingRows}
            deleteApi={provinceApi}
            refreshGrid={RefreshGrid}
            editUrl={`/dashboard/Province/edit`}
            showDelete={false}
            showEdit={AccessControl.checkPermissions(userPermissions,["Province:Edit"])}
          /> */}
      </Paper>
    </RtlProvider>
  );
}

export default ProvincePanel;
